import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { ForkliftModel } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { SceneTracker } from '@/components/landing/scene-tracker'
import { SceneLayer } from '@/components/landing/scene-layer'
import { ChapterNav } from '@/components/landing/chapter-nav'
import { Hero } from '@/components/landing/hero'
import { StoryChapter } from '@/components/landing/story-chapter'
import { Configurator } from '@/components/landing/configurator'
import { Marquee } from '@/components/landing/marquee'
import { Industries } from '@/components/landing/industries'
import { Savings } from '@/components/landing/savings'
import { Testimonials } from '@/components/landing/testimonials'
import { Support } from '@/components/landing/support'
import { Faq } from '@/components/landing/faq'
import { QuoteForm } from '@/components/landing/quote-form'
import { loadModels } from '@/lib/models'
import { siteConfig } from '@/constants/site'
import { chapters } from '@/constants/content'

interface HomeProps {
    models: ForkliftModel[]
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    const { models } = await loadModels()

    return {
        props: { models },
        revalidate: 60
    }
}

const Home: FC<HomeProps> = ({ models }): ReactNode => {
    return (
        <Layout>
            <Seo description={siteConfig.description} />

            <SceneTracker />
            <SceneLayer models={models} />
            <ChapterNav />

            <Hero models={models} />

            {chapters.map(chapter => (
                <StoryChapter key={chapter.id} chapter={chapter} />
            ))}

            <Configurator models={models} />
            <Marquee />
            <Industries />
            <Savings />
            <Testimonials />
            <Support />
            <Faq />
            <QuoteForm models={models} />
        </Layout>
    )
}

export default Home
